import type { IChoiceGroupOption } from "@fluentui/react";
import { ChoiceGroup } from "@fluentui/react";
import React, { useEffect, useState, type FormEvent } from "react";
import type { NodeProps, Node } from "@xyflow/react";
import type { PedestriansInZoneData } from "../../../api";
import { Zone } from "../../../api";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode, { zoneOptions } from "./action-config-node";
import { useTranslation } from "react-i18next";
import { useUpdateNodeData } from "@/lib/hooks/reactflow";

type PedestriansInZoneNode = Node<InterfaceToRecord<PedestriansInZoneData & ExtraNodeData>>;

export default function PedestriansInZone(props: NodeProps<PedestriansInZoneNode>): JSX.Element {
    const { t } = useTranslation();
    const [selectedZone, setSelectedZone] = useState(props.data.zone ?? Zone.ONE);
    const updateNode = useUpdateNodeData<PedestriansInZoneNode>(props.id);

    // We have to set the data to prevent undefined values
    useEffect(() => {
        updateNode({ zone: selectedZone });
    }, [selectedZone, updateNode]);

    function onChange(
        _e?: FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption,
    ): void {
        if (!option) {
            return;
        }
        setSelectedZone(option.key as Zone);
    }

    return (
        <ActionConfigNode nodeKind={props.type} {...props.data}>
            <ChoiceGroup options={zoneOptions(t)} selectedKey={selectedZone} onChange={onChange} />
        </ActionConfigNode>
    );
}
